import {ConfigObjectType} from '@wallaby-ui/core';
import {encounterContainer} from '@wallaby-ui/document';
import * as React from 'react';

import {NotFoundComponentBox} from '../NotFoundComponentBox';

interface OwnProps {
  encounterId: string;
  config: ConfigObjectType;
  encounterData: any;
  encounterIsLoading: boolean;
  query: any;
  changeQuery: (newValue: any) => void;
}

type Props = OwnProps;

export const EncounterLayout: React.FC<Props> = (props) => {
  const {
    config,
    encounterId,
    encounterData,
    encounterIsLoading,
    query,
    changeQuery,
  } = props;

  return encounterId ? (
    <encounterContainer.EncounterDetailContainer
      config={config}
      encounterId={encounterId}
      encounterData={encounterData}
      encounterIsLoading={encounterIsLoading}
      query={query}
      changeQuery={changeQuery}
    />
  ) : (
    <NotFoundComponentBox />
  );
};

EncounterLayout.displayName = 'EncounterLayout';
